const LazyLoadGrid = {
  parts: [
    'container',
    'heading',
    'productGrid',
    'errorText',
    'emptyStateWrapper',
    'emptyStateText',
    'sentinelFooter',
    'endOfResultsText',
  ],
  baseStyle: {
    container: {
      className: 'sf-product-list-lazy-grid',
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: 'container.xxl',
      paddingBottom: '24px',
      paddingTop: {base: '32px', lg: '120px'},
      paddingX: {base: 'unset', lg: 20},
      width: '100%',
    },
    heading: {
      as: 'h1',
      color: 'grayAlpha.90',
      marginBottom: {base: 5.25, lg: 15.25},
      fontFamily: 'heading',
      fontSize: {base: '2.75xl', lg: '4.75xl'},
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: 1.2,
      letterSpacing: {base: '-0.28px', lg: '-0.4px'},
      fontVariantNumeric: 'lining-nums proportional-nums',
      paddingX: {base: '20px', lg: 'unset'},
      scrollMarginTop: {
        base: 'calc(var(--header-height, 72px) + 24px)',
        lg: 'calc(var(--header-height, 80px) + 32px)',
      },
    },
    productGrid: {
      columns: [2, 2, 3, 4],
      spacingX: 1,
      spacingY: {base: 3, lg: 8},
    },
    errorText: {
      color: 'red.500',
    },
    emptyStateWrapper: {
      paddingTop: 8,
      paddingBottom: 4,
    },
    emptyStateText: {
      color: 'grayAlpha.70',
      fontSize: 'sm',
    },
    sentinelFooter: {
      display: 'none',
      justify: 'center',
      paddingTop: 8,
      paddingBottom: 4,
    },
    endOfResultsText: {
      color: 'grayAlpha.70',
      fontSize: 'sm',
    },
  },
  variants: {
    default: {},
  },
  defaultProps: {
    variant: 'default',
  },
};

export default LazyLoadGrid;
